function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4262",
  "data-name": "Group 4262",
  transform: "translate(-3951.703 20738.295)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1583",
  "data-name": "Path 1583",
  d: "M7.181,27l-1.667.461c-1.2.33-2.5.719-3.554-.279-1.176-1.113-.63-2.458-.275-3.736l.4-1.456A14.568,14.568,0,1,1,7.181,27Z",
  transform: "translate(3951.703 -20738.295)",
  fill: "#f86542",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_371",
  "data-name": "Ellipse 371",
  cx: 2.014,
  cy: 2.014,
  r: 2.014,
  transform: "translate(3970.947 -20726.059)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_372",
  "data-name": "Ellipse 372",
  cx: 2.014,
  cy: 2.014,
  r: 2.014,
  transform: "translate(3964.596 -20726.059)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_373",
  "data-name": "Ellipse 373",
  cx: 2.014,
  cy: 2.014,
  r: 2.014,
  transform: "translate(3957.978 -20726.059)",
  fill: "#fff"
}));

var SvgIconChat = function SvgIconChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.011,
    height: 28.989,
    viewBox: "0 0 29.011 28.989",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chat.526a48ca.svg";
export { ForwardRef as ReactComponent };